var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImagineArt = function SvgImagineArt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 26 26",
    className: "ImagineArt_svg__size-6.5"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.65 10.563c-2.727-.64-5.818-.841-5.064-5.828l5.517 1.545L26 6.732C25.9 3.002 22.846 0 19.088 0H6.874A6.874 6.874 0 0 0 0 6.87v5.778c0 1.935 1.043 2.475 2.35 2.789 2.727.64 5.818.841 5.064 5.828L1.898 19.72 0 19.268A6.87 6.87 0 0 0 6.874 26h12.252A6.874 6.874 0 0 0 26 19.13v-5.778c0-1.935-1.043-2.475-2.35-2.789ZM20.873 13a12.465 12.465 0 0 0-7.867 7.863A12.436 12.436 0 0 0 5.14 13c3.77-1.256 6.647-4.233 7.866-7.863A12.436 12.436 0 0 0 20.873 13Z"
  })));
};
export default SvgImagineArt;